/**
 * Overlay keyboard rules (AssistantOverlayHost's global keydown listener).
 *
 * Ctrl/Cmd+`.` toggles the panel. (Not Ctrl+J: that's Chrome/Edge's native
 * "Downloads" shortcut and intermittently steals the keystroke.)
 *
 * Escape closes the panel only when focus is inside it and nothing else
 * handled the key first: the command palette, notification center, image
 * lightbox and pickers all close on Escape too, and one press shouldn't
 * close both them and the assistant.
 */

type KeyEventLike = Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'altKey' | 'defaultPrevented'>;

export function isToggleHotkey(e: KeyEventLike): boolean {
  return (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && e.key === '.';
}

export function shouldCloseOnEscape(
  e: KeyEventLike,
  panel: Element | null,
  focused: Element | null = typeof document !== 'undefined' ? document.activeElement : null,
): boolean {
  if (e.key !== 'Escape' || e.defaultPrevented) return false;
  return !!panel && !!focused && panel.contains(focused);
}
